module.exports = __webpack_public_path__ + "static/media/Banner-informacion-de-credito.eee6488e.jpg";